export function mapCountryCodeToCountry(code) {
    const countries = {
        FR: 'France',
        IRE: 'Ireland',
        CAN: 'Canada',
        AUS: 'Australia',
        NZ: 'New Zealand',
        JPN: 'Japan',
        GB: 'Great Britain'
    };

    return countries[code] ? countries[code] : code;
}

export function mapCurrencyCodeToSymbol(code) {
    const currencies = {
        "GBP": "£",
        "EUR": '€',
        "USD": "$",
        "JPY": "¥"
    };

    return currencies[code] ? currencies[code] : code;
}

/**
 *
 * @param input array
 * @param seed must be unique number, can use new Date().getTime()
 * @returns shuffled array
 */
export const shuffleArray = (input, seed) => {
    const arr = input;
    let currentIndex = arr.length;
    let temporaryValue;
    let randomIndex;

    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
    // A simple formula used to generate a sequence of pseudo-random numbers.
    const random = (max) => {
        const s = (seed * 9301 + 49297) % 233280;
        return Math.floor((s / 233280) * max);
    };

    while (0 !== currentIndex) {
        randomIndex = random(currentIndex);
        currentIndex -= 1;
        temporaryValue = arr[currentIndex];
        arr[currentIndex] = arr[randomIndex];
        arr[randomIndex] = temporaryValue;
    }
    return arr;
};



// WEBPACK FOOTER //
// ./src/client/utils/dataHelper.js